export function commafy (num) {
  if ((num + '').trim() === '') {
    return ''
  }
  if (isNaN(num)) {
    return ''
  }
  num = num + ''
  if (/^.*\..{1}$/.test(num)) {
    num = num + '0'
    const re = /(-?\d+)(\d{3})/
    while (re.test(num)) {
      num = num.replace(re, '$1,$2')
    }
  } else if (/^.*\..*$/.test(num)) {
    const pointIndex = num.lastIndexOf('.')
    let intPart = num.substring(0, pointIndex)
    const pointPart = num.substring(pointIndex + 1, num.length)
    intPart = intPart + ''
    const re = /(-?\d+)(\d{3})/
    while (re.test(intPart)) {
      intPart = intPart.replace(re, '$1,$2')
    }
    num = intPart + '.' + pointPart
  } else {
    num = num + '.00'
    const re = /(-?\d+)(\d{3})/
    while (re.test(num)) {
      num = num.replace(re, '$1,$2')
    }
  }
  return num
}
export function delcommafy (num) {
  if ((num + '').trim() === '') {
    return ''
  }
  num = num.replace(/,/gi, '')
  return num
}
